import clsx from "clsx"
import {GatsbyImage, IGatsbyImageData} from "gatsby-plugin-image"
import {CSSProperties} from "react"
import "./Spacer.css"

interface SpacerProps extends React.HTMLAttributes<HTMLDivElement> {
    paddingHeight?: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10
    borderHeight?: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10
    marginHeight?: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10
    color?: "green" | "gray"
    top?: boolean
    bottom?: boolean
    backgroundImage: IGatsbyImageData | null | undefined
    backgroundImageAlt: string | null | undefined
    imageClassName?: string
    imageStyle?: CSSProperties
}

const Spacer = (props: SpacerProps) => {
    const {
        paddingHeight,
        marginHeight,
        borderHeight = 0,
        backgroundImage,
        backgroundImageAlt,
        color,
        top = false,
        bottom = false,
        children,
        className,
        imageClassName,
        imageStyle,
        ...otherProps
    } = props

    let paddigHeightClass = ""
    switch (paddingHeight) {
        case 0:
            paddigHeightClass = "ph-0-typ6"
            break
        case 1:
            paddigHeightClass = "ph-1-typ6"
            break
        case 2:
            paddigHeightClass = "ph-2-typ6"
            break
        case 3:
            paddigHeightClass = "ph-3-typ6"
            break
        case 4:
            paddigHeightClass = "ph-4-typ6"
            break
        case 5:
            paddigHeightClass = "ph-5-typ6"
            break
        case 6:
            paddigHeightClass = "ph-6-typ6"
            break
        case 7:
            paddigHeightClass = "ph-7-typ6"
            break
        case 8:
            paddigHeightClass = "ph-9-typ6"
            break
        case 9:
            paddigHeightClass = "ph-9-typ6"
            break
        case 10:
            paddigHeightClass = "ph-10-typ6"
            break
    }
    let borderHeightClass = ""
    switch (borderHeight) {
        case 0:
            borderHeightClass = "bh-0-typ6"
            break
        case 1:
            borderHeightClass = "bh-1-typ6"
            break
        case 2:
            borderHeightClass = "bh-2-typ6"
            break
        case 3:
            borderHeightClass = "bh-3-typ6"
            break
        case 4:
            borderHeightClass = "bh-4-typ6"
            break
        case 5:
            borderHeightClass = "bh-5-typ6"
            break
        case 6:
            borderHeightClass = "bh-6-typ6"
            break
        case 7:
            borderHeightClass = "bh-7-typ6"
            break
        case 8:
            borderHeightClass = "bh-9-typ6"
            break
        case 9:
            borderHeightClass = "bh-9-typ6"
            break
        case 10:
            borderHeightClass = "bh-10-typ6"
            break
    }
    let marginHeightClass = ""
    switch (marginHeight) {
        case 0:
            marginHeightClass = "mh-0-typ6"
            break
        case 1:
            marginHeightClass = "mh-1-typ6"
            break
        case 2:
            marginHeightClass = "mh-2-typ6"
            break
        case 3:
            marginHeightClass = "mh-3-typ6"
            break
        case 4:
            marginHeightClass = "mh-4-typ6"
            break
        case 5:
            marginHeightClass = "mh-5-typ6"
            break
        case 6:
            marginHeightClass = "mh-6-typ6"
            break
        case 7:
            marginHeightClass = "mh-7-typ6"
            break
        case 8:
            marginHeightClass = "mh-9-typ6"
            break
        case 9:
            marginHeightClass = "mh-9-typ6"
            break
        case 10:
            marginHeightClass = "mh-10-typ6"
            break
    }

    return (
        <div
            className={clsx(
                "spacer-typ6",
                top ? "top-typ6" : undefined,
                bottom ? "bottom-typ6" : undefined,
                `${color}-typ6`,
                borderHeightClass,
                marginHeightClass,
                className,
            )}
            {...otherProps}
        >
            <div className={clsx("white-space-typ6", color ? `${color}-typ6` : "", paddigHeightClass)}>
                {backgroundImage && backgroundImageAlt && (
                    <GatsbyImage
                        style={imageStyle}
                        className={clsx(imageClassName, {"image-typ6": color})}
                        image={backgroundImage}
                        alt={backgroundImageAlt}
                    />
                )}
            </div>
        </div>
    )
}

export default Spacer
